import script from "./AQIcon.vue?vue&type=script&setup=true&lang=ts"
export * from "./AQIcon.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__